import React, { lazy } from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  num: '01',
  title: 'Bases de la Pastelería Desde Cero',
  cover: 'https://cdn.magicpatterns.com/uploads/6Cwxbt3BfxoN28znZM8EJ4/PAGINA_1.png'
}, {
  num: '02',
  title: 'Tortas y Bizcochos Profesionales',
  cover: 'https://cdn.magicpatterns.com/uploads/2gMBtkL3T7PR1XQvyY1RHi/PAGINA_1.png'
}, {
  num: '03',
  title: 'Pastelería para Emprender Desde Casa',
  cover: 'https://cdn.magicpatterns.com/uploads/cUHojyF3uPaY8VhAxPtM56/PAG_1.png'
}, {
  num: '04',
  title: 'Postres y Dulces Más Vendidos',
  cover: 'https://cdn.magicpatterns.com/uploads/bue7TVbCkF9LfLe38JcSxa/PAGINA_1.png'
}, {
  num: '05',
  title: 'Decoración y Presentación Profesional',
  cover: 'https://cdn.magicpatterns.com/uploads/kqnV4gN4aiR2VS5hT77mE3/PAGINA_1.png'
}, {
  num: '06',
  title: 'Maestría Pastelera y Crecimiento del Negocio',
  cover: 'https://cdn.magicpatterns.com/uploads/hBRtQLTq5KjKbT2GNwCxA7/PAGINA_1.png'
}];
export function TomosSection() {
  const [ref, isVisible] = useReveal();
  return <section className="py-12 md:py-16 px-6 bg-[#fff8f9]" data-id="element-226">
      <div className="max-w-5xl mx-auto" data-id="element-227">
        <div className="text-center mb-8" data-id="element-228">
          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-229">
            ♡ Contenido del MegaPack ♡
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a]" data-id="element-230">
            ¿Qué incluye{' '}
            <span className="italic text-[#e89aaa]" data-id="element-231">el MegaPack?</span>
          </h2>
          <p className="text-base text-[#8b6f47] max-w-xl mx-auto mt-3" data-id="element-232">
            6 Tomos premium para llevarte de la pasión al negocio.
          </p>
        </div>

        <div ref={ref} className={`reveal grid grid-cols-1 md:grid-cols-2 gap-5 ${isVisible ? 'is-visible' : ''}`} data-id="element-233">
          {TOMOS.map((tomo, i) => <div key={i} className="group relative bg-white rounded-3xl p-5 border border-[#f4b6c2]/30 shadow-[0_8px_30px_rgba(232,154,170,0.05)] hover:shadow-[0_20px_50px_rgba(232,154,170,0.12)] hover:-translate-y-1 transition-all duration-500" data-id="element-234">
              <div className="flex items-center gap-4" data-id="element-235">
                {/* Cover thumbnail */}
                <div className="shrink-0 w-20 sm:w-24 aspect-[3/4] rounded-xl overflow-hidden shadow-[0_6px_20px_rgba(232,154,170,0.18)] border border-[#f4b6c2]/30 bg-gradient-to-br from-[#fdf2f4] to-[#f8d7da]" data-id="element-236">
                  {tomo.cover ? <img src={tomo.cover} alt={`Portada Tomo ${tomo.num} — ${tomo.title}`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" data-id="element-237" /> : <div className="w-full h-full flex flex-col items-center justify-center text-center p-2" data-id="element-238">
                      <span className="font-serif italic text-3xl text-[#e89aaa] leading-none" data-id="element-239">
                        {tomo.num}
                      </span>
                      <span className="text-[8px] text-[#8b6f47]/70 mt-1 tracking-wide uppercase" data-id="element-240">
                        Próximamente
                      </span>
                    </div>}
                </div>

                <div className="flex-1 min-w-0" data-id="element-241">
                  <span className="text-[#e89aaa] text-[10px] font-bold tracking-[0.25em] uppercase mb-2 block" data-id="element-242">
                    Tomo {tomo.num}
                  </span>
                  <h3 className="text-lg md:text-xl font-serif font-bold text-[#6b4f3a] leading-tight" data-id="element-243">
                    {tomo.title}
                  </h3>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}